<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
    yz-card
      yz-dialog-normal-header(title="Confirm claim status change" @close="onClose")

      yz-dialog-normal-content.px-6.py-6
        .text-neutral-700
          .yz-medium-body-md.mb-2 Are you sure you want to change this claim status?
          .yz-regular-body-sm.mb-4
            span.mr-1(v-if="isReverting") This action will remove the existing deductions.
            span Notes added will appear in the log.

          // Status comparison section
          yz-card.pa-3(outlined, color="yz-neutral-200")
            // Current status
            v-row(no-gutters)
              v-col(cols="5")
                .yz-medium-body-sm.text-neutral-500 Current status
              v-col(cols="7")
                .yz-medium-body-sm(:class="currentStatusColor") {{ currentStatusLabel }}

            // New status
            v-row.mt-3(no-gutters)
              v-col(cols="5")
                .yz-medium-body-sm.text-neutral-500 New status
              v-col(cols="7")
                .yz-medium-body-sm(:class="newStatusColor") {{ newStatusLabel }}

            // Recorded deductions
            v-row.mt-3(v-if="newStatus !== 'rejected'" no-gutters)
              v-col(cols="5")
                .yz-medium-body-sm.text-neutral-500 Recorded deductions
              v-col(cols="7")
                .d-flex.flex-column.gap-2
                  v-row(no-gutters)
                    v-col(cols="6")
                      .yz-medium-body-sm.text-neutral-700 Admin fee
                    v-col(cols="6", style="text-align: right")
                      .yz-regular-body-sm.text-neutral-700 {{ adminFee | displayPrice($currency) }}
                  v-row(no-gutters)
                    v-col(cols="6")
                      .yz-medium-body-sm.text-neutral-700 Rejected amount
                    v-col(cols="6", style="text-align: right")
                      .yz-regular-body-sm.text-neutral-700 {{ rejectedAmount | displayPrice($currency) }}

          // Warning message for received status
          .mt-4(v-if="newStatus === 'received'")
            yz-card.pa-3(outlined, color="yz-warning-100", border-color="yz-warning-500")
              .d-flex.gap-2
                yz-icon(color="yz-warning-500" size="20") $yzi-alert-circle
                .yz-regular-body-sm.text-neutral-700
                  | Once
                  span.font-semibold.ml-1 status
                  |  is changed to
                  span.font-semibold.ml-1 Received
                  | , you will not be able to change the
                  span.font-semibold.ml-1 claim status
                  |  or
                  span.font-semibold.ml-1 amount
                  | . However, you can still upload new files or edit remarks.

          // Note field
          .mt-6
            .yz-medium-body-sm.text-neutral-700.mb-2 Note (optional)
            yz-textarea(v-model="remarks" placeholder="Enter note here" rows="4" background-color="white" width="full")

      yz-dialog-normal-actions(save-label="Confirm" cancel-label="Cancel" :loading="isLoading" @save="onConfirm" @cancel="onCancel")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    currentStatus: {
      type: String,
      default: ''
    },
    newStatus: {
      type: String,
      default: ''
    },
    adminFee: {
      type: Number,
      default: 0
    },
    rejectedAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      remarks: null,
      isLoading: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    currentStatusLabel() {
      const statusMap = {
        submitted: 'Submitted',
        approved: 'Approved',
        rejected: 'Rejected',
        received: 'Received'
      }
      return statusMap[this.currentStatus] || this.currentStatus
    },
    newStatusLabel() {
      const statusMap = {
        submitted: 'Submitted',
        approved: 'Approved',
        rejected: 'Rejected',
        received: 'Received'
      }
      return statusMap[this.newStatus] || this.newStatus
    },
    currentStatusColor() {
      const colorMap = {
        submitted: 'text-warning-500',
        approved: 'text-success-500',
        rejected: 'text-danger-500',
        received: 'text-success-500'
      }
      return colorMap[this.currentStatus] || 'text-neutral-700'
    },
    newStatusColor() {
      const colorMap = {
        submitted: 'text-warning-500',
        approved: 'text-success-500',
        rejected: 'text-danger-500',
        received: 'text-success-500'
      }
      return colorMap[this.newStatus] || 'text-neutral-700'
    },
    isReverting() {
      return this.newStatus === 'submitted'
    }
  },
  methods: {
    onConfirm() {
      this.isLoading = true
      this.$emit('confirmed', this.remarks)
    },
    onCancel() {
      this.$emit('canceled')
      this.onClose()
    },
    onClose() {
      this.showDialog = false
    }
  }
}
</script>

<style scoped></style>
